import type { IconData } from '@stacksjs/iconify-core'

export const userFemale: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m403.6 343.656l-72.823-47.334L344.043 272h23.428a48 48 0 0 0 44.119-66.908L361.581 90.57a112.029 112.029 0 0 0-211.162 0L100.41 205.092A48 48 0 0 0 144.529 272h23.428l13.266 24.322l-72.823 47.334A79.72 79.72 0 0 0 72 410.732V496h368v-85.268a79.73 79.73 0 0 0-36.4-67.076M408 464H104v-53.268a47.84 47.84 0 0 1 21.841-40.246l97.66-63.479L186.953 240h-42.424a16 16 0 0 1-14.72-22.27l50.172-114.9l.448-1.143a80.029 80.029 0 0 1 151.142 0l.2.58l50.42 115.463a16 16 0 0 1-14.72 22.27h-42.424L288.5 307.007l97.661 63.479A47.84 47.84 0 0 1 408 410.732Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default userFemale
